module.exports = __webpack_public_path__ + "static/media/icon-customer-prequalify.f7bb30af.svg";